// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__u9tW_","quote":"style_quote__oWRDn"};